import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-icon';
import '../common/bn-action';

class TagDisplayList extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
        margin: .5em .5em 1.5em 0;
      }
      :host > div {
        display: inline-block;
        white-space: nowrap;
      }
      .preset-tag {
        color: white;
        color: black;
        margin: 0 1.5em .5em 0;
      }
      .preset-tag > div {
        text-align: left;
      }
      .preset-tag .key {
        font-size: 0.65em;
        color: var(--gray-60);
      }
      .tag {
        font-size: .9em;
        background-color: var(--gray-40);
        border-radius: 6px;
        padding: 3px 0;
        margin: 0 1em .5em 0;
      }
      .tag > div {
        display: inline;
      }
      .tag .key {
        border: 1px solid var(--gray-40);
        background-color: var(--gray-10);
        padding: 2px 6px;
        border-radius: 6px 0 0 6px;
        color: var(--gray-80);
      }
      .tag .value {
        color: var(--black-base);
        padding: 2px 6px;
      }
    `];
  }

  render() {
    if (!this.tags && !this.presetTags) {
      return html``;
    }

    return html`
      ${this.presetTags.map((presetTag) => this._renderTag(presetTag, true))}
      <br/>
      ${this.tags.map((tag) => this._renderTag(tag))}
    `;
  }

  _renderTag(tag, isPreset) {
    if (!tag.properties) {
      return html ``;
    }

    // All on one line as may be rendered inline
    return html`
      <div class="${isPreset ? 'preset-tag' : 'tag'}">
        <div class="key">${tag.properties.key}</div><div class="value">${tag.properties.value || `No ${tag.properties.key}`}</div>
      </div>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    let newTags = (this.entity && this.entity.entities) || [];
    // Filter down to two sets of tags
    const newPresetTags = newTags.filter((t) => t.class.includes('preset'));
    newTags = newTags.filter((t) => !t.class.includes('preset'));

    const alphaSort = (a, b) => a.properties.key.localeCompare(b.properties.key);
    // sort tags alphabetically by key
    newTags.sort(alphaSort);
    newPresetTags.sort(alphaSort);

    this.tags = newTags;
    this.presetTags = newPresetTags;
  }
}

window.customElements.define('tag-display-list', TagDisplayList);
